import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { trackEvent } from '../utils/analytics';

const WHATSAPP_LINK = "https://wa.me/393921037894?text=Ciao%2C%20vorrei%20un%20preventivo%20gratuito%20per%20uno%20sgombero.%20Posso%20inviarvi%20le%20foto%3F";

const reasons = [
  {
    icon: FiIcons.FiClock,
    title: "Risposta veloce",
    desc: "Ti rispondiamo in poco tempo, foto e preventivo direttamente in chat."
  },
  {
    icon: FiIcons.FiSearch,
    title: "Sopralluogo e valutazione gratis",
    desc: "Nessun costo, nessun impegno."
  },
  {
    icon: FiIcons.FiShield,
    title: "Prezzo chiaro",
    desc: "Quello che ti diciamo è quello che paghi. Zero sorprese."
  }
];

export default function WhyChooseUs() {
  return (
    <section className="py-20 md:py-28 bg-[#080808] relative overflow-hidden border-y border-white/5">
      {/* Decorative Blur */}
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-maaich-green/5 to-transparent pointer-events-none"></div>

      <div className="container mx-auto px-5 relative z-10">
        {/* Intestazione */}
        <div className="text-center mb-16 md:mb-20">
          <motion.h2 
            className="text-4xl md:text-6xl font-display uppercase italic mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            Perché ci <span className="text-maaich-lime">Scelgono</span>
          </motion.h2>
          <motion.p 
            className="text-lg md:text-xl text-white/60 font-body font-light"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Prima di decidere, scoprilo in 2 minuti su WhatsApp.
          </motion.p>
        </div>

        {/* Griglia Motivi */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-16">
          {reasons.map((item, idx) => (
            <motion.div 
              key={idx}
              className="bg-white/5 border border-white/10 p-8 rounded-lg hover:border-maaich-lime/30 transition-colors duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.15 }}
            >
              <div className="w-14 h-14 bg-maaich-black border border-maaich-lime rounded-full flex items-center justify-center mb-6">
                <SafeIcon icon={item.icon} className="text-2xl text-maaich-lime" />
              </div>
              <h3 className="font-display uppercase text-xl italic mb-3 text-white">{item.title}</h3>
              <p className="text-white/60 font-body text-sm leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Area Social Proof & CTA */}
        <motion.div 
          className="max-w-3xl mx-auto bg-maaich-black border border-white/10 p-8 md:p-12 text-center relative overflow-hidden"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          {/* Subtle Glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-maaich-lime/5 blur-[60px] pointer-events-none"></div>

          <div className="relative z-10">
            <div className="flex justify-center gap-1 text-maaich-lime text-xl mb-4">
              {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiIcons.FiStar} className="fill-current" />)}
            </div>
            <p className="font-display uppercase italic text-lg md:text-2xl mb-8">
              Centinaia di spazi liberati con successo.<br/>
              <span className="text-sm text-white/50 tracking-widest mt-2 block">Affidati a chi ti dà certezze.</span>
            </p>
            
            <div className="flex flex-col gap-4 items-center">
              <a 
                href={WHATSAPP_LINK} 
                target="_blank" 
                rel="noreferrer"
                onClick={() => trackEvent('whatsapp_click', 'fiducia')}
                className="w-full md:w-auto bg-maaich-lime text-black font-display text-xl md:text-2xl px-10 py-5 uppercase italic flex items-center justify-center gap-3 hover:bg-white transition-colors duration-300 active:scale-95 shadow-lg shadow-maaich-lime/20"
              >
                <SafeIcon icon={FiIcons.FiMessageCircle} className="text-3xl" />
                Scrivici su WhatsApp
              </a>
              <p className="text-white/50 text-sm mt-3 font-body">
                oppure chiama <a href="tel:+393516488306" className="text-white font-medium hover:text-maaich-lime transition-colors">351 648 8306</a>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}